var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1637_19718)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.59657 11.9973H3.26411C2.91071 11.9973 2.5718 11.8569 2.32191 11.607C2.07202 11.3572 1.93164 11.0182 1.93164 10.6648V7.33369C1.93164 6.98029 2.07202 6.64138 2.32191 6.39149C2.5718 6.14161 2.91071 6.00122 3.26411 6.00122H13.9238C14.2772 6.00122 14.6161 6.14161 14.866 6.39149C15.1159 6.64138 15.2563 6.98029 15.2563 7.33369V10.6648C15.2563 11.0182 15.1159 11.3572 14.866 11.607C14.6161 11.8569 14.2772 11.9973 13.9238 11.9973H12.5914",
    stroke: "#092147",
    strokeWidth: 1.33247,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.59766 6.00128V2.00388C4.59766 1.82718 4.66785 1.65772 4.79279 1.53278C4.91773 1.40784 5.08719 1.33765 5.26389 1.33765H11.9262C12.1029 1.33765 12.2724 1.40784 12.3973 1.53278C12.5223 1.65772 12.5924 1.82718 12.5924 2.00388V6.00128",
    stroke: "#092147",
    strokeWidth: 1.33247,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9262 9.33228H5.26389C4.89594 9.33228 4.59766 9.63056 4.59766 9.99851V13.9959C4.59766 14.3639 4.89594 14.6621 5.26389 14.6621H11.9262C12.2942 14.6621 12.5924 14.3639 12.5924 13.9959V9.99851C12.5924 9.63056 12.2942 9.33228 11.9262 9.33228Z",
    stroke: "#092147",
    strokeWidth: 1.33247,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1637_19718"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9896,
    height: 15.9896,
    fill: "white",
    transform: "translate(0.599609 0.00512695)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.72dddf8492a82475b43831a6c840ee6e.svg";
export { ForwardRef as ReactComponent };